import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VTabs,{attrs:{"centered":"","background-color":"blue-grey","dark":"","slider-color":"yellow"},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c(VTab,{on:{"click":function($event){return _vm.$emit('tipoOficioSeleccionado', 'entrante');}}},[_vm._v("Entrantes")]),_c(VTab,{on:{"click":function($event){return _vm.$emit('tipoOficioSeleccionado', 'generado');}}},[_vm._v("Generados")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }